import Vue from 'vue'
import Vuex from 'vuex'
import User from './modules/User'
import Common from './modules/Common'
import Canteen from './modules/Canteen'
import { getModule } from 'vuex-module-decorators'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    User,
    Common,
    Canteen
  }
})

export default store

const UserModule = getModule(User, store)
const CommonModule = getModule(Common, store)
const CanteenModule = getModule(Canteen, store)

export { UserModule, CommonModule, CanteenModule }
